<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="aq.total.value" class="v3-count">{{ aq.total.value }}</span>
      <span class="sub">Newest first · rationale attached to each</span>
    </div>

    <V3Skeleton v-if="aq.isLoading.value && !aq.total.value" shape="list" :heading="false" />
    <div v-else-if="!aq.total.value" class="v3-task-empty" v-testid="testid + '-empty'">Nothing waiting for review.</div>

    <template v-else>
      <button v-if="aq.showAll.value" class="v3-viewall" type="button" v-testid="testid + '-show-less'" @click="aq.showAll.value = false">
        Show less
      </button>

      <div class="v3-list">
        <div
          v-for="r in aq.shownRows.value"
          :key="r.document_lf_evaluation_id || r.doc_id || r.reference"
          class="v3-row v3-row--q"
          :class="{ 'v3-row--boundary': aq.isBoundary(r) }"
          role="button"
          tabindex="0"
          v-testid="testid + '-row-' + (r.document_lf_evaluation_id || r.doc_id || r.reference)"
          @click="open(r)"
        >
          <div>
            <div class="v3-row-title">{{ aq.docName(r) }}</div>
            <div class="v3-row-sub">{{ aq.rowSub(r) }}</div>
            <button v-if="aq.isBoundary(r)" class="v3-cal-link" type="button" v-testid="testid + '-row-' + (r.document_lf_evaluation_id || r.doc_id || r.reference) + '-calibrate'" @click.stop="open(r)">
              <span class="ms">balance</span> Compare against peers in calibration
            </button>
          </div>
          <span class="v3-level">{{ aq.levelText(r) }}</span>
          <span class="v3-spill" :class="`v3-spill--${aq.pillTone(r)}`"><span class="dot"></span>{{ aq.pillLabel(r) }}</span>
        </div>
      </div>

      <button v-if="aq.hasMore.value" class="v3-viewall" type="button" v-testid="testid + '-view-all'" @click="aq.showAll.value = !aq.showAll.value">
        {{ aq.showAll.value ? 'Show less' : 'View all (' + aq.total.value + ')' }}
      </button>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { attentionQueue } from "@rm-ui/homepage/attentionQueue";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) AttentionQueue — thin Vue 2 presentation over the shared
// `attentionQueue` composable (@rm-ui/homepage/attentionQueue), backed by
// POST Report/reviewQueue. Completed evaluations awaiting review with recommended
// level + boundary flag (quiet left tick + Verify + calibration link). Matches
// the prototype V3Queue. Sibling: rm-portal-beta AttentionQueueWidget.vue.
export default {
  name: "cLandingV3AttentionQueue",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const aq = attentionQueue({
      http: axios,
      getLimit: () => props.definition.limit || 5,
      getScope: () => props.definition.scope || "all",
    });
    return { aq };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3AttentionQueue";
    },
    title() {
      return this.definition.title || "All Reviews (Admin View)";
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
